import { useToolEntryField } from '#plugin-chat/hooks/useToolEntryField.ts';
import type { ErasedToolMessageFormatters } from '#plugin-chat/lib/tool/message-formatters.ts';

/**
 * Reads the registered tool's `message` formatters from the assistant-ui
 * model context. The `<Tool>` component attaches the formatters onto each
 * tool entry so the transport (call-side prose) and the UI (Show-details
 * JSX rendering) can re-derive prose on demand from `(args, dataset?,
 * output?)`.
 *
 * Returns `undefined` when the tool isn't registered or doesn't declare
 * `message` formatters — consumers fall back to a generic placeholder.
 */
export function useToolMessage(toolName: string | undefined): ErasedToolMessageFormatters | undefined {
  return useToolEntryField<ErasedToolMessageFormatters>(toolName, 'message');
}
